import { bootstrapApplication } from '@angular/platform-browser';
import { LoadChatbot } from './app/features/load-chatbot/load-chatbot.component';
import { createCustomElement } from '@angular/elements';
import { UiChatBotSaComponent } from './app/features/chat-bot/components/ui-chat-bot-sa/ui-chat-bot-sa.component';
import {
  HttpClient,
  provideHttpClient,
  withInterceptors
} from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  ErrorHandler,
  importProvidersFrom,
  inject,
  provideAppInitializer
} from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { Router, Routes, provideRouter } from '@angular/router';
import { BootstrapAppComponent } from './app/bootstrap-app.component';
import { PageNotFoundComponent } from './app/features/page-not-found/page-not-found.component';
import { CustomLoaderFactory } from './app/shared/utils/translate-loader';
import * as Sentry from '@sentry/angular';
import posthog from 'posthog-js';
import { environment } from './environments/environment';
import { posthogInterceptor } from './app/shared/interceptors/posthog.interceptor';

const routes: Routes = [
  { path: '', component: PageNotFoundComponent, pathMatch: 'full' },
  {
    path: ':subdomain/:funnelSelector/:lang',
    component: LoadChatbot
  },
  {
    path: ':subdomain/:lang',
    component: LoadChatbot,
    children: [
      {
        path: '',
        component: UiChatBotSaComponent
      }
    ]
  },
  { path: '**', component: PageNotFoundComponent }
];
if (environment.environmentName !== 'local') {
  Sentry.init({
    dsn: 'https://989382c3b46fa34127e59430ab564122@o4510585567313920.ingest.de.sentry.io/4510617539772496',
    environment: environment.environmentName,
    release: `ui-chat-bot@${environment.version}`,

    tracesSampleRate: 0.2
  });
}

bootstrapApplication(BootstrapAppComponent, {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptors([posthogInterceptor])),
    importProvidersFrom([
      BrowserAnimationsModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: CustomLoaderFactory,
          deps: [HttpClient]
        }
      })
    ]),
    // sentry config
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler()
    },
    {
      provide: Sentry.TraceService,
      deps: [Router]
    },
    provideAppInitializer(() => {
      inject(Sentry.TraceService);
      if (environment.posthog.enabled) {
        posthog.init(environment.posthog.apiKey, {
          api_host: `${environment.posthog.host}/relay-MzPS`,
          defaults: '2025-05-24',
          cross_subdomain_cookie: environment.posthog.crossSubdomainCookie
        });
      }
    })
  ]
})
  .then((moduleRef) => {
    const injector = moduleRef.injector;
    const el2 = createCustomElement(UiChatBotSaComponent, {
      injector
    });
    customElements.define('ui-chat-bot-sa-element', el2);
  })
  .catch((err) => console.error(err));
